module.exports = __webpack_public_path__ + "static/media/2.210f8b20.png";